import { render } from "./VideoMyInvestList.vue?vue&type=template&id=0be07e04&scoped=true"
import script from "./VideoMyInvestList.vue?vue&type=script&lang=js"
export * from "./VideoMyInvestList.vue?vue&type=script&lang=js"

import "./VideoMyInvestList.vue?vue&type=style&index=0&id=0be07e04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be07e04"]])

export default __exports__